import { Close } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React from 'react'

export const PreviewDocument = ({ open, pdfBase64, setOpen }) => {
    return (

        <Dialog
            open={open}
            fullScreen
        >
            <DialogTitle>
                <Typography
                    variant="h5"
                    component="h5"
                    
                >
                    preview document
                </Typography>

                <IconButton
                    aria-label="close"
                    onClick={setOpen}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>

                <iframe
                    title={"preview electronic document"}
                    className='iframe-size-view-pdf'
                    src={pdfBase64}
                />

            </DialogContent>
        </Dialog>
    )
}

